var exports = {
  "M": "FormSurface.module__surface___LXNCU2",
};

module.exports = exports;
